import React from 'react';

import { capitalizeFirstLetter } from '@utils/Util';

import LoaderComponent from '@/components/LoaderComponent';

const ProductWisePriceRange = ({ priceRangeData = {}, isPriceRangeLoading, predictedCost, category }) => {
	const medianPrice = priceRangeData?.medianPrice || 0;
	const fobPrice = predictedCost;

	const percentageChange = medianPrice !== 0 ? ((fobPrice - medianPrice) / fobPrice) * 100 : 0;
	const absolutePercentageChange = Math.abs(percentageChange)?.toFixed(2);
	const garmentCategory = category ? capitalizeFirstLetter(category) : 'Category not available';

	let message = '';
	if (medianPrice === 0) {
		message = 'Median price data not available for comparison.';
	} else {
		if (percentageChange <= -15) {
			message = `This is significantly lower ( ${absolutePercentageChange}% ) than what this brand typically pays for similar ${garmentCategory} from Bangladesh.`;
		} else if (percentageChange > -15 && percentageChange <= -5) {
			message = `This is significantly lower ( ${absolutePercentageChange}% ) than what this brand typically pays for similar ${garmentCategory} from Bangladesh.`;
		} else if (percentageChange > -5 && percentageChange <= 5) {
			message = `This is close to what this brand typically pays for similar ${garmentCategory} from Bangladesh`;
		} else if (percentageChange > 5 && percentageChange <= 15) {
			message = `This is (${absolutePercentageChange}%) higher than what this brand typically pays for similar ${garmentCategory} from Bangladesh.`;
		} else if (percentageChange > 15) {
			message = `This is significantly higher (${absolutePercentageChange}%) than what this brand typically pays for similar ${garmentCategory} from Bangladesh.`;
		}
	}

	return isPriceRangeLoading ? (
		<LoaderComponent loading={isPriceRangeLoading} />
	) : (
		<div className="product-wise-price-message mt-2">
			<p className="regular-14 gray_dark_01 text-center">{message}</p>
		</div>
	);
};

export default ProductWisePriceRange;
